<button class="ant-typography-copy" [uiTooltipTitle]="copied ? copedTooltip : copyTooltip" [class.ant-typography-copy-success]="copied" (click)="onClick()" type="button" ui-tooltip ui-trans-button>
  <ng-container *nzStringTemplateOutlet="copied ? copedIcon : copyIcon; let icon">
    <i [uiType]="icon" ui-icon></i>
  </ng-container>
</button>
